// Production tarayicisinda kullanici/aile verisinin unutulmus bir debug veya
// ucuncu taraf logu ile DevTools console'a yazilmasini merkezi olarak engeller.
// Development ve test ortamlarinda tanilama davranisi degismez.
if (process.env.NODE_ENV === "production" && typeof console !== "undefined") {
  ["log", "info", "debug", "warn", "error", "trace", "table", "dir"].forEach((method) => {
    try { console[method] = () => {}; } catch {}
  });
}
